import Visitors from '@/views/exhibitor/dashboard/Visitors.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    name: 'exhibitor-visitors',
    path: 'visitors',
    component: Visitors,
    meta: {
      title: '来場者一覧',
      actor: actors.exhibitor,
      auth: auths.required,
    },
  },
];

export default {
  routes,
};
